// extracted by mini-css-extract-plugin
export var siteNav = "blog-module--site-nav--4cGb0";
export var siteTitle = "blog-module--site-title--EElEt";
export var siteAvatar = "blog-module--site-avatar--158Ld";
export var siteAbout = "blog-module--site-about--jxNJT";
export var bio = "blog-module--bio--sPeT9";
export var textWrapper = "blog-module--text-wrapper--TaZX0";
export var socialWrapper = "blog-module--social-wrapper--YCjEl";
export var articles = "blog-module--articles--tJa8a";
export var article = "blog-module--article--fqe1U";
export var articleImage = "blog-module--article-image--Pl4kg";
export var articleText = "blog-module--article-text--wG3Ww";
export var articleTitle = "blog-module--article-title--dVJZ9";
export var date = "blog-module--date--iYjN1";
export var tags = "blog-module--tags--V6hB6";
export var excerpt = "blog-module--excerpt--UeQox";
export var tag = "blog-module--tag--SpgSB";
export var viewAllPosts = "blog-module--view-all-posts--LIvnd";
export var footerLink = "blog-module--footer-link--cZS7M";
export var imgWrapper = "blog-module--img-wrapper--6mnZM";